import { defineStore } from 'pinia';
import { apiService } from '@/services/apiService';

export const useDataStore = defineStore('dataStore', {
  state: () => ({
    data: {
      categories: [],
      products: [],
      feedbacks: [],
      jobsNeeds: [],
      projects: [],
      partenaires: [],
    },
    loading: false,
    error: null,
  }),

  actions: {
    parseCollectionResponse(payload, nestedKey) {
      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload?.data)) return payload.data;
      if (nestedKey && Array.isArray(payload?.data?.[nestedKey])) return payload.data[nestedKey];
      if (nestedKey && Array.isArray(payload?.[nestedKey])) return payload[nestedKey];
      return [];
    },

    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const [
          categoriesResponse,
          productsResponse,
          feedbacksResponse,
          jobsNeedsResponse,
          projectsResponse,
          partenairesResponse,
        ] = await Promise.all([
          apiService.getCategories(),
          apiService.getProducts(),
          apiService.getFeedbacks(),
          apiService.getJobsNeeds(),
          apiService.getProjects(),
          apiService.getPartenaires(),
        ]);

        this.data.categories = this.parseCollectionResponse(categoriesResponse.data, 'categories');
        this.data.products = this.parseCollectionResponse(productsResponse.data, 'products');
        this.data.feedbacks = this.parseCollectionResponse(feedbacksResponse.data, 'feedbacks');
        this.data.jobsNeeds = this.parseCollectionResponse(jobsNeedsResponse.data, 'jobsNeeds');
        this.data.projects = this.parseCollectionResponse(projectsResponse.data, 'projects');
        this.data.partenaires = this.parseCollectionResponse(partenairesResponse.data, 'partenaires');

      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    // ✅ Optional: Keep this for other pages
    async fetchProductsByCategory(categoryId) {
      this.loading = true;
      this.error = null;
      try {
        const response = await apiService.getProducts({ category: categoryId });
        this.data.products = this.parseCollectionResponse(response.data, 'products');
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    async subscribeUser(email) {
      this.loading = true;
      this.error = null;
      try {
        const response = await apiService.submitSubscription({ email });
        console.log('Subscribed with email:', response.data);
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Subscription failed';
        console.log(this.error);
      } finally {
        this.loading = false;
      }
    },

    async loginUser(credentials) {
      this.loading = true;
      this.error = null;
      try {
        const response = await apiService.login(credentials);
        this.token = response.data.token;
        this.user = response.data.user;
        localStorage.setItem('token', JSON.stringify(this.token));
        localStorage.setItem('user', JSON.stringify(this.user));
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Échec de la connexion';
        console.log(error.response);
      } finally {
        this.loading = false;
      }
    },

    async signupUser(userDetails) {
      this.loading = true;
      this.error = null;
      try {
        const response = await apiService.register(userDetails);
        this.token = response.data.token;
        this.user = response.data.user;
        localStorage.setItem('token', JSON.stringify(this.token));
        localStorage.setItem('user', JSON.stringify(this.user));
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Échec de l\'inscription';
        alert(this.error);
      } finally {
        this.loading = false;
      }
    },

    async submitJobApplication(formData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await apiService.submitRecruitment(formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response.data;
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Submission failed';
        console.error('Error submitting job application:', error.response ?? error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async submitGeneralApplication(formData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await apiService.submitRecruitment(formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response.data;
      } catch (error) {
        this.error = error.response ? error.response.data.message : 'Submission failed';
        console.error('Error submitting general application:', error.response ?? error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
});

